import React from 'react'
import { Box } from '@mui/material'
import AccountTypeSelector from '../molecules/AccountTypeSelector'
import GmailConfigurationSection from '../molecules/GmailConfigurationSection'
import ManualConfigurationSection from '../molecules/ManualConfigurationSection'
import ExternalServiceSection from '../molecules/ExternalServiceSection'
import { EMAIL_ACCOUNT_TYPES } from '../../../utils/campaignConstants'

const EmailSettingsTabContent = ({
  control,
  errors,
  accountType,
  isPasswordShown,
  languageGSD,
  userEditState,
  onAccountTypeChange,
  onTogglePassword
}) => {
  const originalAccountType = userEditState?.emailSettings?.accountType

  return (
    <Box className="p-3" style={{ minHeight: '25rem' }}>
      <AccountTypeSelector
        onChange={onAccountTypeChange}
        accountType={accountType}
        originalAccountType={originalAccountType}
      />

      {accountType === EMAIL_ACCOUNT_TYPES.GMAIL_OAUTH2 && (
        <GmailConfigurationSection
          languageGSD={languageGSD}
          userEditState={userEditState}
        />
      )}

      {accountType === EMAIL_ACCOUNT_TYPES.USERNAME_PASSWORD && (
        <ManualConfigurationSection
          control={control}
          errors={errors}
          isPasswordShown={isPasswordShown}
          onTogglePassword={onTogglePassword}
        />
      )}

      {accountType === EMAIL_ACCOUNT_TYPES.EXTERNAL_SERVICE && (
        <ExternalServiceSection
          control={control}
          errors={errors}
          isPasswordShown={isPasswordShown}
          onTogglePassword={onTogglePassword}
        />
      )}
    </Box>
  )
}

export default EmailSettingsTabContent
